export enum Colour {
  GREY,
  GREEN,
  YELLOW,
  RED,
}
